"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildEecProduct = void 0;
const calculateProductIfrs_1 = require("./calculateProductIfrs");
const getVariant_1 = require("../helper/getVariant");
function buildEecProduct({ product, quantity, position, appointment, variant, tenant, offsetShare, orderDiscountRate, }) {
    let eecPrice = product.price.gross.amount;
    let specialPrice = null;
    const hasSpecialPrice = 1;
    if (product.originalPrice) {
        specialPrice = eecPrice;
        eecPrice = product.originalPrice.gross.amount;
    }
    const eecProduct = {
        name: product.title,
        id: product.manufacturerSku,
        price: eecPrice,
        metric9: specialPrice,
        metric10: specialPrice ? hasSpecialPrice : null,
        category: product.trackingPath.join('/'),
        variant: variant || (0, getVariant_1.getVariant)(appointment, product.productType),
    };
    if (typeof quantity === 'number') {
        eecProduct.quantity = quantity;
    }
    if (product.discountBadgeId) {
        eecProduct.dimension2 = product.discountBadgeId;
    }
    if (position) {
        eecProduct.position = position;
    }
    if (tenant !== undefined &&
        quantity !== undefined &&
        offsetShare !== undefined &&
        orderDiscountRate !== undefined) {
        const metric5 = (0, calculateProductIfrs_1.calculateProductIfrs)({
            product,
            tenant,
            quantity,
            orderDiscountRate,
            offsetShare,
            appointment,
        });
        eecProduct.metric5 = Number(metric5.toFixed(2));
    }
    return eecProduct;
}
exports.buildEecProduct = buildEecProduct;
//# sourceMappingURL=buildEecProduct.js.map